import type { AdsStrings } from "./ads.vi.ts";

/** English twin of `ads.vi.ts`. */
export const adsEn: AdsStrings = {
  calling: "Calling an ad over, one moment",
  unavailable: "No ad is around right now, try again a little later.",
  skipped: "The ad ended early, so no gift this time. Watch it to the end next time!",
  needNetwork: "Connect to the internet to watch an ad.",
  hint: {
    watch: "Watch an ad for a hint",
    note: "One short ad for one hint, not a single coin spent.",
    or: "Or pay with gold",
    got: "Your hint is here, use it now!",
  },
  double: {
    watch: (gold) => `Watch an ad for ${gold} more gold`,
    got: (gold) => `Ka-ching! ${gold} more gold flew into your purse!`,
    later: "Your bonus gold is flying over, keep playing.",
    already: "This level already gave its bonus.",
  },
  gift: {
    label: "Gift chest",
    title: "Daily gift chest",
    body: (gold) => `Watch one short ad to open the chest and take ${gold} gold home.`,
    left: (n, total) => `${n} of ${total} chests left today`,
    open: "Watch an ad, open the chest",
    empty: "All of today's chests are open. Come back tomorrow for new ones!",
    got: (gold) => `The chest pops open! You got ${gold} gold!`,
    later: "The chest is open, your gold arrives in a moment.",
    close: "Later",
    done: "Awesome!",
  },
  privacy: {
    title: "Privacy",
    adChoices: "Ad privacy choices",
    policy: "Privacy policy",
    deleteOpen: "Delete my data",
    deleteTitle: "Delete your data",
    deleteBody:
      "Permanently deletes your profile on our server, including progress, gold, items, your leaderboard name and recovery code. This phone starts over from the beginning too.",
    deleteSure: "Are you sure? Once deleted, it cannot come back.",
    deleteYes: "Delete for good",
    deleteNo: "No, keep it",
    deleteNeedNetwork: "Connect to the internet to delete your data on our server.",
    deleteFailed: "Could not delete it yet, try again in a moment.",
    updates: "The game updates itself through Google Play.",
  },
};
